//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { selectIsAuthenticated } from '@/redux/selectors/authSelectors';
import { useAppSelector } from '@/redux/hooks';

const AuthRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) history.push('/');
  }, [isAuthenticated]);

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default AuthRoute;
